// extracted by mini-css-extract-plugin
export default {"container":"Homepage_container__WfsZB","inner-container":"Homepage_inner-container__jBsYf","primary":"Homepage_primary__jmvEB","quote":"Homepage_quote__oIn4H"};